module.exports = __webpack_public_path__ + "7a55763a04a14b62a17c2308c453601b.png";